import providerProfitFullcont from "./providerProfit-fullcont.html";

const dialog = require("../../../../../components/dialog/dialog");
const fullcontEntity = require("../../../../../components/fullcont/fullcont-entity");
const fullcontHandler = require("../../../../../components/fullcont/fullcont-handler");
const fullcontReport = require("../../../../../components/fullcont/fullcont-report");
const providerProfitDt = require("./providerProfit-dt");
const providerProfitMenu = require("./providerProfit-menu");
const { formCopy } = require("./providerProfit-fullcont-form");
const { form } = require("./providerProfit-fullcont-form");
const MtGenerator = require("./providerProfit-multitable-generator");
const snack = require("../../../../../components/snack/snack");
// const {providerProfitMT} = require('./providerProfit-fullcont-multitable')
const providerProfitMT = undefined; //no MT just add this like undefined
const providerProfitFetch = require("./providerProfit-fetch");
const providerProfit = require("./providerProfit");
const style = require("../../../../../components/report/report-style");
const css = style.get();

const scrim = require("../../../../../components/scrim/scrim");

let iframe;
let topData = null;
let tableData = null;

/****************ELEMENTS*****************/
var htmlFc = {};
var HTMLwasSelected = false;

function HTMLselect(detail) {
  fullcontHandler.HTMLselect(
    "providerProfit", //database table name****
    "providerProfit", //dest entity on js
    "providerProfit-fullcont",
    providerProfitFullcont,
    form,
    formCopy,
    providerProfitMT,
    editDialog,
    deleteDialog,
    dtCall,
    htmlFc
  );

  HTMLwasSelected = true;
  iframe = document.getElementById("reportIframe");
  // htmlFc.hasFiles = true
  // fullcontHandler.rightsControl(htmlFc)
} /**/

export function start(detail) {
  //console.log('providerProfit-dt 5>', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
} /**/

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlFc);
    },
  },
  cancelEdit: {
    start: (detail) => {
      fullcontEntity.cancelEdit(detail, htmlFc);
    },
  },
  deleteEntity: {
    start: (detail) => {
      fullcontEntity.deleteEntity(detail, htmlFc);
    },
  },
  deleteFromDialog: {
    start: (detail) => {
      deleteFromDialog(detail, htmlFc);
    },
  },
  discard: {
    start: (detail) => {
      fullcontHandler.discard(detail, htmlFc);
    },
  },
  fullcontOptions: {
    start: (detail) => {
      providerProfitMenu.start(detail, "htmlDt", htmlFc);
    },
  },
  hide: {
    start: (detail) => {
      fullcontEntity.hide(detail, htmlFc);
    },
  },
  prepareAdd: {
    start: (detail) => {
      fullcontEntity.prepareAdd(detail, htmlFc);
    },
  },
  prepareEdit: {
    start: (detail) => {
      fullcontHandler.prepareEdit(detail, htmlFc);
    },
  },
  saveFromDialog: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  selectOne: {
    start: (detail) => {
      fullcontEntity.selectOne(detail, htmlFc);
    },
  },
  selectOneNoCheck: {
    start: (detail) => {
      fullcontEntity.selectOneNoCheck(detail, htmlFc);
    },
  },
  update: {
    start: (detail) => {
      handler.validate(detail, htmlFc);
    },
  },
  callData: {
    start: (detail) => {
      callData(detail, htmlFc);
    },
  },
  callUnpaidInvoices: {
    start: (detail) => {
      callUnpaidInvoices(detail, htmlFc);
    },
  },
  click: {
    start: (detail) => {
      click(detail, htmlFc);
    },
  },
  printReport: {
    start: (detail) => {
      printReport(detail, htmlFc);
    },
  },
  purchaseFullcont2: {
    start: (detail) => {
      purchaseFullcont2(detail, htmlFc);
    },
  },
}; /**/

function purchaseFullcont2(detail, htmlFc) {
  providerProfit.start({
    dest: detail.dest,
    elem: "purchaseFullcont2",
    id: "purchase-fullcont3",
    act: "showFullcont",
    dbid: detail.dbid,
  });
}

//function to send
function editDialog() {
  dialog.start({
    act: "show",
    id: "saveChanges",
    entity: "providerProfit",
  });
}

function deleteDialog(detail) {
  dialog.start({
    act: "show",
    dest: "providerProfit",
    id: "deleteElem",
    entity: "providerProfit",
    dbid: detail.dbid,
  });
}

function dtCall(act, result) {
  providerProfitDt.start({ act: act, row: result });
}

function addOne(detail, htmlFc) {
  fullcontEntity.addOne(detail, htmlFc);
  setTimeout(() => {
    // providerProfitDt.start({"dest":"providerProfit", "elem":"dt", "act":"select", "entity":"providerProfit"})
  }, 100);
}

function deleteFromDialog(detail, htmlFc) {
  if (parseInt(htmlFc.fullcontHTML.getAttribute("data-DBid")) > 99) {
    fullcontEntity.deleteFromDialog(detail, htmlFc);
    setTimeout(() => {
      providerProfitDt.start({
        dest: "providerProfit",
        elem: "dt",
        act: "select",
        entity: "providerProfit",
      });
    }, 900);
  } else {
    snack.start({ act: "show", id: "accountidisless" });
  }
}

function callData(detail, htmlFc) {
  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountReceivableAll",
    dbid: detail.dbid,
  };

  providerProfitFetch.fetchOne(fetchDetail, (data) => {
    fullcontReport.showFullcont(detail, data, {
      id: "#providerProfit_form_",
      fields: [
        "provider_name",
        "total_earnings",
        "last_24_hours",
        "last_24_hours_income",
        "last_7_days",
        "last_7_days_income",
        "last_15_days",
        "last_15_days_income",
        "last_30_days",
        "last_30_days_income",
        "last_90_days",
        "last_90_days_income",
        "over_90_days",
        "over_90_days_income",
      ],
    });

    topData = data;
  });
}

function callUnpaidInvoices(detail, htmlFc) {
  const container = document.getElementById(
    "multitable-report-provider-profits"
  );

  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountReceivable",
    dbid: detail.dbid,
  };

  providerProfitFetch.fetchUnpaidInvoices(fetchDetail, (data) => {
    fullcontReport.renderProfitInvoices(data, {
      container: container,
      lineRenderer: MtGenerator.unpaid_invoices_list,
      headerHtml: `
        <div class="o54">
          <div class="row">
            <div class="c16"><label class="font-caption label-report">Date</label></div>
            <div class="c16"><label class="font-caption label-report">Code</label></div>
            <div class="c16"><label class="font-caption label-report">Item</label></div>
            <div class="c16"><label class="font-caption label-report">QTY</label></div>
            <div class="c16"><label class="font-caption label-report">Sold QTY</label></div>
            <div class="c16"><label class="font-caption label-report">Profit</label></div>
          </div>
        </div>
      `,
      afterLineRender: (line, item) => {
        fullcontReport.autoAssignValuesByClass(line, item);
      },
    });

    tableData = data;
  });
}

function printReport(detail, htmlFc) {
  if (detail.dbid) {
    generateReport(detail.dbid, detail.entity, detail.reportName);
    return
  }

  const cont = htmlFc.fullcontHTML;
  const id = cont.getAttribute('data-dbid') || null;
  generateReport(id, detail.entity, detail.reportName);
  return

}

function generateReport(dbid, entity, reportName) {
  scrim.showLoading()
  const formData = new FormData();
  formData.append('id', dbid);
  formData.append('type', 'print');
  formData.append('entity', entity);
  formData.append('reportName', reportName);

  const isPdf = true;

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  fetch(`./server/php/report/report-pdf.php`, options)
    .then((response) => {
      clearTimeout(timeout);
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return response.blob();
    })
    .then((blob) => {
      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          scrim.hideLoading()
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }
      } else {
        scrim.hideLoading()
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })

    .catch(error => {
      scrim.hideLoading()
      throw error;
    });
}